<template>
    <div class="clearfix rounded pb-5 mx-auto">
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">PF Settings<span>
                <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / PF Settings</span>
        </h4>
        <div class="ibox mt-4">
            <div class="">
                <form enctype="multipart/form-data" @submit.stop.prevent="formSubmit">
                    <div v-if="$acl['company/savepfsettings'] > 0" id="pf_settings">
                        {{ successmsg }}
                        <div class="clearfix row no-margin ibox-content">
                            <div class="col-md-12 fixed-section-one mb-4">
                                <div class="clearfix approval-container row">
                                    <div class="col-4 approve-level-label">
                                        <div class="approve-level-title">
                                            PF Settings
                                        </div>
                                        <div class="approve-level-description">
                                            The PF Settings
                                            allows for configuring multiple functions of Provident Fund module
                                            including the monthly contribution percentage on the salary component of
                                            an employee, the Fiscal Year period, visual representations, Profit
                                            Distribution methods, and controlling waivers and audit features.
                                        </div>
                                    </div>
                                    <div class="col-8 approve-level-content">
                                        <div class="clearfix px-0 border-bottom">
                                            <div class="clearfix">
                                                <div class=" row mx-1 mt-3 py-2 w-100 align-items-center no-margin" v-if="settings_pf_type == 0">
                                                    <div class="col-md-9 px-0 salary-heads">Enable Provident Fund
                                                        <b-icon icon="info-circle" title="Enable Provident Fund" v-b-tooltip></b-icon></div>
                                                    <div class="col-md-3 text-right"><toggle-button v-model="company_reg_enable" key="company_reg_enable" value="true" :sync="true" :color="{ checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" /></div>
                                                </div>
                                                
                                                <div class="row mx-1 py-2 w-100 align-items-center no-margin form-group px-4" v-if="settings_pf_type == 0">
                                                    <!-- Company Contribution -->
                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <label class="mr-0 col-form-label" style="margin-top: 6px;">Please enter % of company contribution*</label>
                                                        <b-form-input id="company_registered_provident_fund_value" name="company_registered_provident_fund_value" key="company_registered_pf" v-model="company_reg_pf" v-validate="{ required: false, max_value: 20, decimal: 2 }" :state="validateState('company_registered_provident_fund_value')" aria-describedby="company_registered_provident_fund_value-feedback" data-vv-as="Registered provident fund contribution of Company" :disabled="!company_reg_enable"></b-form-input>
                                                        <b-form-invalid-feedback id="company_registered_provident_fund_value">{{ veeErrors.first('company_registered_provident_fund_value') }}</b-form-invalid-feedback>
                                                    </div>

                                                    <!-- Employee Contribution -->
                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <label class="mr-0 col-form-label" style="margin-top: 6px;">Please enter % of employee contribution*</label>
                                                        <b-form-input id="employee_registered_provident_fund_value" name="employee_registered_provident_fund_value" key="employee_registered_pf" v-model="employee_reg_pf" v-validate="{ required: false, max_value: 20, decimal: 2 }" :state="validateState('employee_registered_provident_fund_value')" aria-describedby="employee_registered_provident_fund_value-feedback" data-vv-as="Registered provident fund contribution of Employee" :disabled="!company_reg_enable"></b-form-input>
                                                        <b-form-invalid-feedback id="employee_registered_provident_fund_value">{{ veeErrors.first('employee_registered_provident_fund_value') }}</b-form-invalid-feedback>
                                                    </div>
                                                    
                                                    <!-- Contribution Applied On -->
                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <label class="ml-0 col-form-label" style="margin-top: 6px;">Contribution applied on</label>
                                                        <b-form-group id="reg-pf-group" label="" class="required-field custom-select-arrow text-right mb-0" label-for="reg_pf_based_on">
                                                            <b-form-select id="reg_pf_based_on" name="reg_pf_based_on" v-model="pf_on" v-validate="{ required: true }" :options="pf_bases" :class="{ 'inactive-select-arraow': !company_reg_enable }" :disabled="!company_reg_enable"></b-form-select>
                                                        </b-form-group>
                                                    </div>

                                                </div>

                                                <!-- PF Fund Fiscal Year End -->
                                                <div class="row mx-1 mt-1 py-2 w-100 align-items-center no-margin form-group px-4" v-if="settings_pf_type == 0">
                                                    <div class="col-md-6 pl-0">
                                                        <label class="ml-0 col-form-label" style="margin-top: 6px;">PF Fund Fiscal Year End <b-icon class="" icon="info-circle" title="Select PF Fund Fiscal Year End Month" v-b-tooltip></b-icon></label>
                                                        <b-form-group id="reg-pf-group" label="" class="required-field custom-select-arrow text-right mb-0" label-for="reg_pf_based_on">
                                                            <b-form-select id="reg_pf_year_end" name="reg_pf_year_end" v-model="pf_year_end" v-validate="{ required: true }" :options="m_lists" :class="{ 'inactive-select-arraow': !company_reg_enable }" :disabled="!company_reg_enable"></b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="clearfix rounded px-0 service_length_settings">
                                            <div class="border-bottom pb-3 row">
                                                <div class="col-md-6">
                                                    <p class="service_length_title salary-heads">Service length format
                                                        settings <b-icon class="" icon="info-circle" title="Service length will show on all reports and slips in selected format" v-b-tooltip></b-icon></p>
                                                    <div class="mt-3">
                                                        <div class="toggle_button_tax first salary-heads d-flex">
                                                            <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Only
                                                                Months</div>
                                                            <div
                                                                class="trz_service_button px-0 cmp-child-items text-right">
                                                                <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                    <input data-v-25adc6c0="" type="radio" v-model="company_pf_service_month" class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="no">
                                                                    <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                                        <div data-v-25adc6c0="" class="v-switch-button">
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                            </div>

                                                        </div>
                                                        <div class="toggle_button_tax first salary-heads d-flex">
                                                            <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Year and
                                                                Months</div>
                                                            <div
                                                                class="trz_service_button px-0 cmp-child-items text-right">
                                                                <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                    <input data-v-25adc6c0="" type="radio" v-model="company_pf_service_month" class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="yes">
                                                                    <div data-v-25adc6c0="" class="v-switch-core"
                                                                        style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                                        <div data-v-25adc6c0="" class="v-switch-button">
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="ibox no-shadow border-2 mt-4 gray-border col-md-6">
                                                    <b-overlay rounded="sm" class='payslip-designer-overlay'>
                                                        <div
                                                            class="clearfix service_format_overview mb-3 mt-2 mx-auto px-3 py-4">
                                                            <div class="number_format_header_title font-medium"
                                                                style="font-size: 18px;color: #747474;">Sample Output
                                                            </div>
                                                            <table style="width: 99%;" class="d-table">

                                                                <template v-if="company_pf_service_month == 'no'">
                                                                    <tr>
                                                                        <td class='service_format_overview_td_label py-2 text-secondary border-bottom'>
                                                                            <template>Service Period</template>
                                                                        </td>
                                                                        <td class='service_format_overview_td_value border-bottom py-2'>
                                                                            <template>47 Month(s)</template></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class='service_format_overview_td_label text-secondary py-2'>
                                                                            <template>Membership Period</template></td>
                                                                        <td class='service_format_overview_td_value py-2'>
                                                                            <template>11 Month(s)</template></td>
                                                                    </tr>
                                                                </template>
                                                                <template v-if="company_pf_service_month == 'yes'">
                                                                    <tr>
                                                                        <td class='service_format_overview_td_label py-2 text-secondary border-bottom'>
                                                                            <template>Service Period</template>
                                                                        </td>
                                                                        <td class='service_format_overview_td_value py-2 border-bottom'>
                                                                            <template>3 Year(s) 11 Month(s)</template>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class='service_format_overview_td_label text-secondary py-2'>
                                                                            <template>Membership Period</template></td>
                                                                        <td class='service_format_overview_td_value py-2'>
                                                                            <template>0 Year(s) 11 Month(s)</template>
                                                                        </td>
                                                                    </tr>
                                                                </template>

                                                            </table>
                                                        </div>
                                                    </b-overlay>
                                                </div>
                                            </div>

                                            <p class="service_length_title salary-heads">Profit Distribution Settings
                                                <b-icon class="" icon="info-circle" title="Profit wil distribute according to the selected type" v-b-tooltip></b-icon></p>
                                            <div class="toggle_button_tax first salary-heads d-flex">
                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span
                                                            class="cmp-inner-circle"></span></span>Equal
                                                    Distribution</div>
                                                <div class="trz_service_button px-0 cmp-child-items text-right">
                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                        <input data-v-25adc6c0="" type="radio" v-model="company_pf_profit_distribute_type" class="v-switch-input trz_tax_radio" name="profit_distribute_settings" value="equal">
                                                        <div data-v-25adc6c0="" class="v-switch-core"
                                                            style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                            <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                        </div> 
                                                    </label>
                                                </div>

                                            </div>
                                            <div class="toggle_button_tax first salary-heads d-flex">
                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span
                                                            class="cmp-inner-circle"></span></span>Cumilitive Distribution</div>
                                                <div class="trz_service_button px-0 cmp-child-items text-right">
                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                        <input data-v-25adc6c0="" type="radio" v-model="company_pf_profit_distribute_type" class="v-switch-input trz_tax_radio" name="profit_distribute_settings" value="cumilitive">
                                                        <div data-v-25adc6c0="" class="v-switch-core"
                                                            style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                            <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                        </div>
                                                    </label>
                                                </div>

                                            </div>


                                            <div class=" row mx-1 mt-3 py-2 w-100 align-items-center no-margin border-bottom"
                                                v-if="settings_pf_type == 0">
                                                <div class="col-md-9 px-0 salary-heads">PF Profit Waiver Feature <b-icon class="" icon="info-circle" title="If enabled employees will be able to waive their claim on PF Profit/Interest" v-b-tooltip></b-icon>
                                                </div>
                                                <div class="col-md-3 text-right px-0"><toggle-button v-model="company_pf_profit_waive_feature" key="company_pf_profit_waive_feature" value="true" :sync="true" :color="{ checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" />
                                                </div>
                                            </div>

                                            <div class=" row mx-1 mt-3 py-2 w-100 align-items-center no-margin"
                                                v-if="settings_pf_type == 0">
                                                <div class="col-md-9 px-0 salary-heads">PF Profit Audit Feature <b-icon class="" icon="info-circle" title="If enabled no profit/interest will be allocated to employee until audit" v-b-tooltip></b-icon></div>
                                                <div class="col-md-3 text-right px-0"><toggle-button v-model="company_pf_profit_audit_feature" key="company_pf_profit_audit_feature" value="true" :sync="true" :color="{ checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin"
                                            v-if="$acl['company/savepfsettings'] > 1">
                                            <div class="col-sm-12 text-right mt-4">
                                                <button type="submit" class="btn btn-primary btn-md">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="clearfix row no-margin pt-2 ibox-content mt-3">
                            <div class="col-md-12 fixed-section-one mb-4">
                                <div class="clearfix approval-container row">
                                    <div class="col-4 approve-level-label">
                                        <div class="approve-level-title">
                                            PF Advance Settings
                                        </div>
                                        <div class="approve-level-description">
                                            The PF Advance Settings allows for configuring the functional parameters
                                            of the Provident Fund Advance feature to align with PF Trust Rules and
                                            Regulations. Eligibility of Balances, installment repayment criteria,
                                            interest/service charge structures, Reasons for Advance from PF, Terms
                                            and Condition disclaimers, and also Reasons for denial of Advance can be
                                            set.
                                        </div>
                                    </div>
                                    <div class="col-8 approve-level-content">
                                        <div class="">

                                            <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin"
                                                v-if="settings_pf_type == 0">
                                                <div class="col-md-9 px-0 salary-heads">Can an employee apply for
                                                    multiple advances? <b-icon class="" icon="info-circle"
                                                        title="Can an employee apply for multiple loans?"
                                                        v-b-tooltip></b-icon></div>
                                                <div class="col-md-3 text-right"><toggle-button
                                                        v-model="company_pf_multiple_loan"
                                                        key="company_pf_multiple_loan" value="false" :sync="true"
                                                        :color="{ checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC' }"
                                                        v-validate="{ required: false }" /></div>
                                            </div>

                                            <!-- Start: Rejwan: 23-03-2025 -->
                                            <!-- <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin" v-if="settings_pf_type==0">
                                                        <div class="col-md-9 px-0 salary-heads">PF advance will be issued based on the balance of: <b-icon class="" icon="info-circle" title="Registered Provident Fund Contribution" v-b-tooltip></b-icon></div>
                                                    </div>
                                                    <table class="table table-sm first-child-no-border">
                                                        <tbody>
                                                        <template>
                                                        <tr class="align-middle">
                                                            <td class="col-md-12 px-0 border-bottom py-2 cmp-parent-items salary-heads border-top-0">
                                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Total contribution</div>
                                                            </td>
                                                            <td class="col-md-7 pl-0 py-2">
                                                                <b-icon class="d-none" icon="info-circle" v-b-tooltip></b-icon>
                                                            </td>
                                                            <td class="col-md-5 text-right pr-3 py-2 icon-off">
                                                                <template>
                                                                    <toggle-button v-model="company_pf_loan_total_contribution" key="company_loan_total_contribution" value="false" :sync="true"  :color="{checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC'}" v-validate="{ required: false }" />
                                                                </template>
                                                            </td>
                                                        </tr>
                                                        <tr class="align-middle">

                                                            <td class="col-md-12 px-0 border-bottom py-2 cmp-parent-items salary-heads border-top-0">
                                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Total distributed profit</div>
                                                            </td>
                                                            <td class="col-md-7 pl-0 py-2">
                                                                <b-icon class="d-none" icon="info-circle" v-b-tooltip></b-icon>
                                                            </td>
                                                            <td class="col-md-5 text-right pr-3 py-2 icon-off">
                                                                <template>
                                                                    <toggle-button v-model="company_pf_loan_distributed_profit" key="company_loan_distributed_profit" value="false" :sync="true"  :color="{checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC'}" v-validate="{ required: false }" />
                                                                </template>
                                                            </td>
                                                        </tr>
                                                        <tr class="align-middle">
                                                            <td class="col-md-12 px-0 py-2 cmp-parent-items salary-heads border-top-0">
                                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Total distributed forfeiture</div>
                                                            </td>
                                                            <td class="col-md-7 pl-0 py-2">
                                                                <b-icon class="d-none" icon="info-circle" v-b-tooltip></b-icon>
                                                            </td>
                                                            <td class="col-md-5 text-right pr-3 py-2 icon-off">
                                                                <template>
                                                                    <toggle-button v-model="company_pf_loan_distributed_forfeiture" key="company_loan_distributed_forfeiture" value="false" :sync="true"  :color="{checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC'}" v-validate="{ required: false }" />
                                                                </template>
                                                            </td>
                                                        </tr>
                                                        </template>
                                                        </tbody>
                                                    </table> -->
                                            <!-- End: Rejwan: 23-03-2025 -->

                                            <div class="row mx-1 mt-3 pb-4 pt-2 w-100 align-items-center no-margin form-group px-4 border-bottom mb-0"
                                                v-if="settings_pf_type == 0">
                                                <!-- Start: Rejwan: 23-03-2025 -->
                                                <!-- <div class="col-md-6 pl-0 align-bottom">
                                                            <label class="mr-0 col-form-label" style="margin-top: 6px;">% of PF balance applicable for loan</label>

                                                            <b-input-group class="radius-left-0 gray-input" append="%">
                                                            <b-form-input id="pf_loan_applicable_percent" name="pf_loan_applicable_percent" v-model="pf_loan_applicable_percent" v-validate="{ required: true, max_value:100, decimal:2 }" :state="validateState('pf_loan_applicable_percent')" aria-describedby="pf_loan_applicable_percent-feedback" data-vv-as="% of PF balance applicable for loan" class="" ></b-form-input> 
                                                            </b-input-group>
                                                            <b-form-invalid-feedback id="pf_loan_applicable_percent">{{ veeErrors.first('pf_loan_applicable_percent') }}</b-form-invalid-feedback>
                                                        </div> -->
                                                <!-- End: Rejwan: 23-03-2025 -->

                                                <!-- <div class="col-md-6 pl-0 align-bottom">
                                                            <b-form-invalid-feedback id="pf_loan_applicable_percent">{{ veeErrors.first('pf_loan_applicable_percent') }}</b-form-invalid-feedback>
                                                        </div> -->

                                                <!-- Start: Rejwan: 23-03-2025 -->
                                                <!-- <div class="col-md-6 pr-0 align-bottom">
                                                            <label class="mr-0 col-form-label" style="margin-top: 6px;">Maximum installment for PF Advance</label>

                                                            <b-input-group class="radius-left-0 gray-input" append="Month(s)">
                                                            <b-form-input id="pf_loan_max_installment_limit" name="pf_loan_max_installment_limit" v-model="pf_loan_max_installment_limit" v-validate="{ required: true, max_value:60}" :state="validateState('pf_loan_max_installment_limit')" aria-describedby="pf_loan_max_installment_limit-feedback" data-vv-as="Maximum Installment Limit" class="" ></b-form-input> 
                                                            </b-input-group>
                                                            <b-form-invalid-feedback id="pf_loan_max_installment_limit">{{ veeErrors.first('pf_loan_max_installment_limit') }}</b-form-invalid-feedback>
                                                        </div> -->
                                                <!-- End: Rejwan: 23-03-2025 -->

                                                <!-- <div class="col-md-6 pl-0 align-bottom">
                                                            <b-form-invalid-feedback id="pf_loan_max_installment_limit">{{ veeErrors.first('pf_loan_max_installment_limit') }}</b-form-invalid-feedback>
                                                        </div> -->

                                                <!-- Start: Rejwan: 23-03-2025 -->
                                                <pf-advance-slab></pf-advance-slab>
                                                <!-- End: Rejwan: 23-03-2025 -->

                                                <div class="col-md-6 pl-0 mt-3 align-bottom">
                                                    <label class="ml-0 col-form-label" style="margin-top: 6px;">PF
                                                        advance interest
                                                        settings</label>
                                                    <b-form-group id="reg-pf-company_pf_loan_plus_one-group" label=""
                                                        class="required-field custom-select-arrow mb-0"
                                                        label-for="company_pf_loan_plus_one">
                                                        <b-form-select id="company_pf_loan_plus_one"
                                                            name="company_pf_loan_plus_one"
                                                            v-model="company_pf_loan_plus_one"
                                                            v-validate="{ required: true }"
                                                            :options="pf_loan_installment_deduction_type"
                                                            :class="{ 'inactive-select-arraow': !company_reg_enable }"
                                                            :disabled="!company_reg_enable"></b-form-select>
                                                    </b-form-group>
                                                </div>
                                                <template v-if="company_pf_loan_plus_one == 'plus_one'">

                                                    <div class="col-md-6 pl-0">
                                                        <label class="ml-0" style="margin-top: 6px;">Number of extra
                                                            installment <b-icon class="" icon="info-circle"
                                                                title="This is the number of extra installment employee need pay as interest of PF Advance."
                                                                v-b-tooltip></b-icon></label>
                                                        <b-form-group id="extra-installment-group" label=""
                                                            class="required-field custom-select-arrow text-right mb-0"
                                                            label-for="company_pf_extra_installment">
                                                            <b-form-input id="company_pf_extra_installment"
                                                                name="company_pf_extra_installment"
                                                                v-model="company_pf_extra_installment"
                                                                v-validate="{ required: true, max_value: 20, }"
                                                                :state="validateState('company_pf_extra_installment')"
                                                                aria-describedby="company_pf_extra_installment-feedback"
                                                                data-vv-as="Number of extra installment"></b-form-input>
                                                            <b-form-invalid-feedback
                                                                id="company_pf_extra_installment ">{{
                                                                veeErrors.first('company_pf_extra_installment')
                                                                }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>

                                                </template>
                                                <template v-if="company_pf_loan_plus_one == 'plus_one_fixed'">

                                                    <div class="col-md-6 pl-0">
                                                        <label class="ml-0" style="margin-top: 6px;">Interest Rate
                                                            <b-icon class="" icon="info-circle"
                                                                title="This is the interest rate of PF Advance."
                                                                v-b-tooltip></b-icon></label>
                                                        <b-form-group id="extra-company_pf_interest_rate-group" label=""
                                                            class="required-field custom-select-arrow text-right mb-0"
                                                            label-for="company_pf_interest_rate">
                                                            <b-form-input id="company_pf_interest_rate"
                                                                name="company_pf_interest_rate"
                                                                v-model="company_pf_interest_rate"
                                                                v-validate="{ required: true, max_value: 100, }"
                                                                :state="validateState('company_pf_interest_rate')"
                                                                aria-describedby="company_pf_interest_rate-feedback"
                                                                data-vv-as="Interest Rate"></b-form-input>
                                                            <b-form-invalid-feedback id="company_pf_interest_rate ">{{
                                                                veeErrors.first('company_pf_interest_rate')
                                                                }}</b-form-invalid-feedback>
                                                        </b-form-group>


                                                        <label class="ml-0" style="margin-top: 6px;">Number of extra
                                                            installment <b-icon class="" icon="info-circle"
                                                                title="This is the number of extra installment employee need pay as interest of PF Advance."
                                                                v-b-tooltip></b-icon></label>
                                                        <b-form-group id="extra-installment-group" label=""
                                                            class="required-field custom-select-arrow text-right mb-0"
                                                            label-for="company_pf_extra_installment">
                                                            <b-form-input id="company_pf_extra_installment"
                                                                name="company_pf_extra_installment"
                                                                v-model="company_pf_extra_installment"
                                                                v-validate="{ required: true, max_value: 20, }"
                                                                :state="validateState('company_pf_extra_installment')"
                                                                aria-describedby="company_pf_extra_installment-feedback"
                                                                data-vv-as="Number of extra installment"></b-form-input>
                                                            <b-form-invalid-feedback
                                                                id="company_pf_extra_installment ">{{
                                                                veeErrors.first('company_pf_extra_installment')
                                                                }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>

                                                </template>
                                                <template
                                                    v-if="company_pf_loan_plus_one == 'govt_interest' || company_pf_loan_plus_one == 'fixed_interest'">

                                                    <div class="col-md-6 pl-0">
                                                        <label class="ml-0" style="margin-top: 6px;">Interest Rate
                                                            <b-icon class="" icon="info-circle"
                                                                title="This is the interest rate of PF Advance."
                                                                v-b-tooltip></b-icon></label>
                                                        <b-form-group id="extra-installment-group" label=""
                                                            class="required-field custom-select-arrow text-right mb-0"
                                                            label-for="company_pf_interest_rate">
                                                            <b-form-input id="company_pf_interest_rate"
                                                                name="company_pf_interest_rate"
                                                                v-model="company_pf_interest_rate"
                                                                v-validate="{ required: true, max_value: 100, }"
                                                                :state="validateState('company_pf_interest_rate')"
                                                                aria-describedby="company_pf_interest_rate-feedback"
                                                                data-vv-as="Interest Rate"></b-form-input>
                                                            <b-form-invalid-feedback id="company_pf_interest_rate ">{{
                                                                veeErrors.first('company_pf_interest_rate')
                                                                }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>

                                                </template>

                                                <div class="row mx-1 py-2 no-margin border-bottom align-items-center">
                                                    <div class="col-md-9 px-0 salary-heads">Enable PF Advance Reason
                                                        Display <b-icon class="" icon="info-circle"
                                                            title="If enabled, employees have to select a reason for loan."
                                                            v-b-tooltip></b-icon></div>
                                                    <div class="col-md-3 text-right"><toggle-button
                                                            v-model="pf_enable_loan_reason" key="pf_enable_loan_reason"
                                                            value="true" :sync="true"
                                                            :color="{ checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC' }"
                                                            v-validate="{ required: false }" /></div>
                                                </div>

                                                <div class="col-sm-12 text-left pl-0 mt-4"
                                                    v-if="pf_enable_loan_reason == true">
                                                    <div class='pf_loan_terms_wrapper show_terms'>
                                                        <pf-loan-reason :pageurl="pgurl"
                                                            :companyid="company_id"></pf-loan-reason>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin"
                                                v-if="$acl['company/savepfsettings'] > 1">
                                                <div class="col-sm-12 text-right mt-4">
                                                    <button type="submit" class="btn btn-primary btn-md">Save</button>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="">
                                            <div class="clearfix rounded col-md-12 px-0">
                                                <div class="row mx-1 py-2 no-margin border-bottom align-items-center">
                                                    <div class="col-md-9 px-0 salary-heads">Enable PF Advance Terms to
                                                        be displayed <b-icon class="" icon="info-circle"
                                                            title="If enabled, employees have to select a reason for loan."
                                                            v-b-tooltip></b-icon></div>
                                                    <div class="col-md-3 text-right"><toggle-button
                                                            v-model="pf_enable_term_agreement"
                                                            key="pf_enable_loan_reason" value="true" :sync="true"
                                                            :color="{ checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC' }"
                                                            v-validate="{ required: false }" /></div>
                                                </div>




                                                <div class="col-sm-12 text-left pl-0 mt-4"
                                                    v-if="pf_enable_term_agreement == true">
                                                    <div class='pf_loan_terms_wrapper show_terms'>

                                                        <ckeditor v-model="pf_loan_term_agreement"></ckeditor>

                                                    </div>
                                                </div>

                                                <div class="row mx-1 py-2 no-margin border-bottom align-items-center">
                                                    <div class="col-md-9 px-0 salary-heads">Enable PF Advance approver
                                                        reminder email <b-icon class="" icon="info-circle"
                                                            title="If enabled, Advance applicant can send a reminder email to approvers."
                                                            v-b-tooltip></b-icon><span
                                                            class="small-salary-head d-block text-secondary font-italic font-medium">Applicant
                                                            can send reminder email to approvers if the advance approval
                                                            is pending for more
                                                            than 30 days.</span></div>
                                                    <div class="col-md-3 text-right"><toggle-button
                                                            v-model="pf_enable_loan_reminder"
                                                            key="pf_enable_loan_reminder" value="true" :sync="true"
                                                            :color="{ checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC' }"
                                                            v-validate="{ required: false }" /></div>
                                                    <!-- <div class="col-md-9 px-0">Applicant can send reminder email to approvers if the advance approval is pending for more than 30 days.</div> -->
                                                </div>


                                                <div class="row mx-1 py-2 no-margin border-bottom align-items-center">
                                                    <div class="col-md-9 px-0 salary-heads">Enable PF Advance Rejection
                                                        Reason Display <b-icon class="" icon="info-circle"
                                                            title="If enabled, approver have to select a reason reject the reason."
                                                            v-b-tooltip></b-icon></div>
                                                    <div class="col-md-3 text-right px-0"><toggle-button
                                                            v-model="pf_enable_loan_reject_reason"
                                                            key="pf_enable_loan_reject_reason" value="true" :sync="true"
                                                            :color="{ checked: '#01524B', unchecked: '#CC5057', disabled: '#f8f8f8' }"
                                                            v-validate="{ required: false }" /></div>
                                                </div>

                                                <div class="col-sm-12 text-left pl-0 mt-4"
                                                    v-if="pf_enable_loan_reject_reason == true">
                                                    <div class='pf_loan_terms_wrapper show_terms'>
                                                        <pf-loan-reject-reason :pageurl="pgurl"
                                                            :companyid="company_id"></pf-loan-reject-reason>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Mustafijur Pf Settelement Policy Settings starts -->
                        <!-- <div class="clearfix row no-margin ibox-content mt-3">
                            <company-pf-settlement-consent-settings></company-pf-settlement-consent-settings>
                        </div> -->
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<style scoped>
.w-45 {
    width: 45% !important;
}

.w-60 {
    width: 60% !important;
}
</style>
<script>

export default {
    props: ['companyid', 'pageurl'],
    mounted() {
    },
    data() {
        return {

            company_unreg_pf: '',
            company_reg_pf: 0,
            employee_reg_pf: 0,
            pf_on: 1,
            pf_bases: [
                { value: "1", text: "Basic Salary" },
                { value: "2", text: "Gross Salary" },
            ],
            m_lists: [{ value: '1', text: 'January' }, { value: '2', text: 'February' }, { value: '3', text: 'March' }, { value: '4', text: 'April' }, { value: '5', text: 'May' }, { value: '6', text: 'June' }, { value: '7', text: 'July' }, { value: '8', text: 'August' }, { value: '9', text: 'September' }, { value: '10', text: 'October' }, { value: '11', text: 'November' }, { value: '12', text: 'December' }],
            pf_year_end: 6,
            eligibility_options: [{ value: 0, text: "0" }, { value: 1, text: "1" }, { value: 2, text: "2" }, { value: 3, text: "3" }, { value: 4, text: "4" }, { value: 5, text: "5" }, { value: 6, text: "6" }, { value: 7, text: "7" }, { value: 8, text: "8" }, { value: 9, text: "9" }, { value: 10, text: "10" }, { value: 11, text: "11" }, { value: 12, text: "12" }, { value: 13, text: "13" }, { value: 14, text: "14" }, { value: 15, text: "15" }, { value: 16, text: "16" }, { value: 17, text: "17" }, { value: 18, text: "18" }, { value: 19, text: "19" }, { value: 20, text: "20" }, { value: 21, text: "21" }, { value: 22, text: "22" }, { value: 23, text: "24" }, { value: 25, text: "25" }, { value: 26, text: "26" }, { value: 27, text: "27" }, { value: 28, text: "28" }, { value: 29, text: "29" }, { value: 30, text: "30" }, { value: 31, text: "31" }, { value: 32, text: "32" }, { value: 33, text: "33" }, { value: 34, text: "34" }, { value: 35, text: "35" }, { value: 36, text: "36" }],
            eligibility_criteria: 0,
            company_reg_enable: false,
            company_unreg_enable: false,
            company_pf_settings: [],
            company_id: this.companyid,
            selection_data: [],
            pgurl: this.$api_url,
            successmsg: '',
            errormsg: [],
            settings_pf_type: 0,
            showoverlay: true,

            /* ALI EDIT */
            company_pf_multiple_loan: true,
            company_pf_loan_total_contribution: true,
            company_pf_loan_distributed_profit: true,
            company_pf_loan_distributed_forfeiture: true,
            company_pf_profit_waive_feature: false,
            company_pf_profit_audit_feature: false,
            pf_enable_term_agreement: false,
            pf_enable_loan_reason: false,
            pf_enable_loan_reject_reason: false,

            pf_enable_loan_reminder: false,
            company_pf_loan_plus_one: 'no_interest',
            company_pf_extra_installment: 1,
            company_pf_interest_rate: 4,
            pf_loan_applicable_percent: 100,
            pf_loan_max_installment_limit: 60,
            pf_loan_term_agreement: '',
            company_pf_service_month: 'no',
            company_pf_profit_distribute_type: 'equal',
            show_term_class: '',
            pf_loan_installment_deduction_type: [
                { value: "no_interest", text: "No interest" },
                { value: "fixed_interest", text: "Fixed interest" },
                { value: "plus_one", text: "Extra installment as interest" },
                { value: "plus_one_fixed", text: "Extra installment with fixed rate interest" },
                { value: "govt_interest", text: "Interest as per Govt. regulation" },
            ],

            /* ALI EDIT */

            movenext: false,


            sortKey: 'name',

            length: 2,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },

            paginatedData: [
                { id: 1, reason: 'Separation from company', description: 'Applies to all members who leave the company under normal circumstances', status: 'Enabled' },
                { id: 2, reason: 'Withdrawal from PF', description: 'Applied to all members opting out of PF', status: 'Enabled' },
                { id: 3, reason: 'Death', description: 'All members who have passed', status: 'Enabled' },
                { id: 4, reason: 'Company Closure', description: 'At company closure', status: 'Enabled' },
                { id: 5, reason: 'Closing of the Fund', description: 'At PF closure', status: 'Enabled' },
                { id: 6, reason: 'Termination from Company', description: 'Termnated / Special Dismissals', status: 'Disabled' },
            ],
            fdata: { status: null, id: null, user_level: null, assigned: '1', password: 'pass1234', password_confirmation: 'pass1234', assigned_companies: [] },

            paginatedData2: [
                { id: 1, reason: 'Damage to Office Equipment', description: 'Employee is charged by HR for damages to devices and equipment', status: 'Enabled' },
                { id: 2, reason: 'Advance Expense Repayment', description: 'Employee owes Company advances against expense claims', status: 'Enabled' },
                { id: 3, reason: 'Digital Device Transfer', description: 'Laptop is transfered to employee', status: 'Enabled' },
                { id: 4, reason: 'Mobile Phone Transfer', description: 'Mobile phone is transfered to employee', status: 'Enabled' },
                { id: 5, reason: 'Motorbike Transfer', description: 'Motorbike is transfered to employee', status: 'Enabled' },
                { id: 6, reason: 'Office Equipment Transfer', description: 'Office equipment is transfered to employee', status: 'Disabled' },
            ],
            status: [

                { value: "1", text: "Enabled" },
                { value: "2", text: "Disabled" },

            ],
            operator_status: [

                { value: "1", text: "Less Than" },
                { value: "2", text: "Equal or Less Than" },

            ],

            addNewVariable: 0,
            length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
            temp_length: 20,

            expenseentries: [
                { service_period: 36, membership_period: 24, employee_contribution: 100, employee_profit: 100, employer_contribution: 60, employer_profit: 60, service_period_condition: true, membership_period_condition: false },
                { service_period: 48, membership_period: 24, employee_contribution: 100, employee_profit: 100, employer_contribution: 80, employer_profit: 80, service_period_condition: true, membership_period_condition: false },
                { service_period: 60, membership_period: 24, employee_contribution: 100, employee_profit: 100, employer_contribution: 100, employer_profit: 100, service_period_condition: true, membership_period_condition: false },
            ],

            tabIndexRFParent: 0,
            search: '',
            button_content: 'Less Than',
        }
    },
    methods: {
        // Mustafijur starts  
        // editSettlement(settlement) {

        //     this.addNewVariable = 0;
        //     this.fdata.reason = settlement.reason;
        //     this.fdata.description = settlement.description;
        //     this.fdata.status = settlement.status;
        //     this.$bvModal.show('bv-modal-example');
        // },
        // editAdjustment(adjustment) {

        //     this.addNewVariable = 0;
        //     this.fdata.reason = adjustment.reason;
        //     this.fdata.description = adjustment.description;
        //     this.fdata.status = adjustment.status;
        //     this.$bvModal.show('bv-modal-example2');
        // },
        // showDetails(settlement) {

        //     this.fdata.reason = settlement.reason;
        //     this.fdata.description = settlement.description;
        //     this.fdata.status = settlement.status;
        //     this.$bvModal.show('bv-modal-show-details');
        // },
        // addSettlement() {
        //     this.addNewVariable = 1;
        //     this.fdata.reason = null;
        //     this.fdata.description = null;
        //     this.$bvModal.show('bv-modal-example');
        // },
        // addAdjustment() {

        //     this.addNewVariable = 1;
        //     this.fdata.reason = null;
        //     this.fdata.description = null;
        //     this.$bvModal.show('bv-modal-example2');
        // },

        // addRow: function () {
        //     this.expenseentries.push({
        //     });

        //     this.tmp++;
        // },
        // deleteRow(index) {

        //     this.expenseentries.splice(index, 1);
        // },

        // Mustafijur ends             
        // this function added by faroque
        showMessage: function () {
            let childdata = { movenext: this.movenext };
            this.$emit('childToParent', childdata);
        },

        // methods goes here..
        // saveSettings() {

        // },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        // resetForm() {
        //     //conseole.log('hererererre');
        //     this.company_unreg_pf = null;
        //     this.company_reg_pf = null;
        //     this.pf_on = 0;
        // },

        // scrollToTop() {
        //     window.scroll({
        //         top: 0,
        //         left: 0,
        //         behavior: 'smooth'
        //     });

        // },
        // showTerms() {
        //     this.show_term_class = 'show_terms';
        // },
        getcompany: function () {
            let formData = new FormData();
            axios.post(this.$api_url + '/company/getcompany', formData)
                .then(function (response) {
                    this.company_id = response.data;

                    if (this.company_id > 0)
                        this.getCompanyPFSettings();
                }.bind(this));
        },
        getCompanyPFSettings: function () {
            let currentObj = this;

            let formData = new FormData();
            axios.post(this.$api_url + '/pf/settings', formData)
                .then(function (response) {
                    if (response.data.data) {
                        this.company_pf_settings = response.data.data;
                        this.settings_pf_type = parseInt(this.company_pf_settings.pf_type.opt_value);
                        this.pf_on = (parseInt(this.company_pf_settings.pf_applied_on.opt_value) > 0) ? parseInt(this.company_pf_settings.pf_applied_on.opt_value) : 2;
                        if (this.settings_pf_type == 1) {
                            this.company_unreg_enable = (parseInt(this.company_pf_settings.company_pf_contribution.status) == 1) ? true : false;
                            this.company_unreg_pf = this.company_pf_settings.company_pf_contribution.opt_value != '0' ? this.company_pf_settings.company_pf_contribution.opt_value : null;
                        } else {
                            // this.company_reg_enable = (parseInt(this.company_pf_settings.company_pf_contribution.status) == 1) ? true : false;

                            //console.log(this.company_pf_settings.pf_contribution.status);
                            //this.$bvToast.toast(this.company_reg_enable, {title: 'Error!',variant: 'danger',solid: true});
                            this.company_reg_pf = this.company_pf_settings.company_pf_contribution.opt_value != '0' ? this.company_pf_settings.company_pf_contribution.opt_value : null;
                            this.employee_reg_pf = this.company_pf_settings.employee_pf_contribution.opt_value != '0' ? this.company_pf_settings.employee_pf_contribution.opt_value : null;
                            
                            this.company_reg_enable = (parseInt(this.company_pf_settings.company_pf_contribution.status) == 1) ? true : false;

                            this.company_pf_loan_plus_one = this.company_pf_settings.pf_loan_installment.opt_value;
                            this.company_pf_extra_installment = this.company_pf_settings.pf_extra_installment.opt_value;
                            this.company_pf_interest_rate = this.company_pf_settings.pf_interest_rate.opt_value;
                            this.pf_loan_applicable_percent = this.company_pf_settings.pf_loan_applicable_percent.opt_value;
                            this.pf_loan_max_installment_limit = this.company_pf_settings.pf_loan_max_installment_limit.opt_value;



                            currentObj.company_pf_multiple_loan = (parseInt(this.company_pf_settings.pf_multiple_loan.opt_value) == 1) ? true : false;
                            currentObj.company_pf_loan_total_contribution = (parseInt(this.company_pf_settings.pf_loan_total_contribution.opt_value) == 1) ? true : false;
                            currentObj.company_pf_loan_distributed_profit = (parseInt(this.company_pf_settings.pf_loan_distributed_profit.opt_value) == 1) ? true : false;
                            currentObj.company_pf_loan_distributed_forfeiture = (parseInt(this.company_pf_settings.pf_loan_distributed_forfeiture.opt_value) == 1) ? true : false;
                            currentObj.pf_enable_loan_reason = (parseInt(this.company_pf_settings.pf_enable_loan_reason.opt_value) == 1) ? true : false;
                            currentObj.pf_enable_loan_reject_reason = (parseInt(this.company_pf_settings.pf_enable_loan_reject_reason.opt_value) == 1) ? true : false;
                            currentObj.pf_enable_loan_reminder = (parseInt(this.company_pf_settings.pf_enable_loan_reminder.opt_value) == 1) ? true : false;
                            currentObj.pf_enable_term_agreement = (parseInt(this.company_pf_settings.pf_enable_term_agreement.opt_value) == 1) ? true : false;
                            currentObj.company_pf_profit_audit_feature = (parseInt(this.company_pf_settings.pf_profit_audit_feature.opt_value) == 1) ? true : false;
                            currentObj.company_pf_profit_waive_feature = (parseInt(this.company_pf_settings.pf_profit_waive_feature.opt_value) == 1) ? true : false;
                            currentObj.company_pf_service_month = (parseInt(this.company_pf_settings.pf_service_month_format.opt_value) == 1) ? 'yes' : 'no';
                            currentObj.company_pf_profit_distribute_type = this.company_pf_settings.pf_profit_distribute_type.opt_value;
                            currentObj.pf_loan_term_agreement = this.company_pf_settings.pf_loan_term_agreement.opt_value_serialized;



                            if (this.company_pf_settings.pf_year_end.opt_value == 0)
                                this.pf_year_end = 6;
                            else
                                this.pf_year_end = this.company_pf_settings.pf_year_end.opt_value;

                            this.eligibility_criteria = this.company_pf_settings.pf_eligibility_criteria.opt_value != '0' ? this.company_pf_settings.pf_eligibility_criteria.opt_value : 0;
                        }

                    }
                    //this.validateState();
                }.bind(this));
        },
        // onToggleChange(field_id, event) {                // added event as second arg
        //     let value = event.value;
        //     this.selection_data[field_id] = (value == true) ? 1 : 0;
        // },
        formSubmit(e) {

            //console.log('here');
            e.preventDefault();

            let formData = new FormData();

            let currentObj = this;
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            let company_pf_multiple_loan = this.company_pf_multiple_loan ? 1 : 0;
            let company_pf_loan_total_contribution = this.company_pf_loan_total_contribution ? 1 : 0;
            let company_pf_loan_distributed_profit = this.company_pf_loan_distributed_profit ? 1 : 0;
            let company_pf_loan_distributed_forfeiture = this.company_pf_loan_distributed_forfeiture ? 1 : 0;
            let pf_enable_loan_reason = this.pf_enable_loan_reason ? 1 : 0;
            let pf_enable_loan_reject_reason = this.pf_enable_loan_reject_reason ? 1 : 0;

            let pf_enable_loan_reminder = this.pf_enable_loan_reminder ? 1 : 0;

            let pf_enable_term_agreement = this.pf_enable_term_agreement ? 1 : 0;


            let company_pf_profit_audit_feature = this.company_pf_profit_audit_feature ? 1 : 0;
            let company_pf_profit_waive_feature = this.company_pf_profit_waive_feature ? 1 : 0;

            let pf_service_month_format = (this.company_pf_service_month == 'no') ? 0 : 1;

            let pf_loan_installment = this.company_pf_loan_plus_one;
            let pf_loan_applicable_percent = this.pf_loan_applicable_percent;

            let company_pf_extra_installment = this.company_pf_extra_installment;
            let company_pf_interest_rate = this.company_pf_interest_rate;

            let pf_loan_max_installment_limit = this.pf_loan_max_installment_limit;
            let pf_loan_term_agreement = this.pf_loan_term_agreement;


            formData.append('company_id', this.company_id);
            formData.append('company_pf_type', this.settings_pf_type);
            formData.append('company_pf_on', this.pf_on);
            formData.append('company_pf_year_end', this.pf_year_end);
            formData.append('company_pf_eligibility_criteria', this.eligibility_criteria);
            formData.append('company_pf_multiple_loan', company_pf_multiple_loan);
            formData.append('company_pf_loan_total_contribution', company_pf_loan_total_contribution);
            formData.append('company_pf_loan_distributed_profit', company_pf_loan_distributed_profit);
            formData.append('company_pf_loan_distributed_forfeiture', company_pf_loan_distributed_forfeiture);
            formData.append('pf_enable_loan_reason', pf_enable_loan_reason);
            formData.append('pf_enable_loan_reject_reason', pf_enable_loan_reject_reason);
            formData.append('pf_enable_loan_reminder', pf_enable_loan_reminder);
            formData.append('pf_enable_term_agreement', pf_enable_term_agreement);
            formData.append('pf_profit_distribute_type', this.company_pf_profit_distribute_type);
            formData.append('pf_service_month_format', pf_service_month_format);
            formData.append('company_pf_profit_audit_feature', company_pf_profit_audit_feature);
            formData.append('company_pf_profit_waive_feature', company_pf_profit_waive_feature);
            formData.append('pf_loan_installment', pf_loan_installment);
            formData.append('company_pf_extra_installment', company_pf_extra_installment);
            formData.append('company_pf_interest_rate', company_pf_interest_rate);
            formData.append('pf_loan_applicable_percent', pf_loan_applicable_percent);
            formData.append('pf_loan_max_installment_limit', pf_loan_max_installment_limit);
            formData.append('pf_loan_term_agreement', pf_loan_term_agreement);

            if (this.settings_pf_type == 1) {
                let pf_status = this.company_unreg_enable ? 1 : 0;
                if (pf_status) {
                    if (!parseFloat(this.company_unreg_pf) > 0) {
                        this.$bvToast.toast('Please select valid Contribution Percentage', { title: 'Error!', variant: 'danger', solid: true });
                        return false;
                    }
                }

                formData.append('company_pf_percentage', this.company_unreg_pf);
                formData.append('company_pf_status', pf_status);
            } else {
                let pf_status = this.company_reg_enable ? 1 : 0;

                if (pf_status) {
                    if (!parseFloat(this.company_reg_pf) > 0 || !parseFloat(this.employee_reg_pf) > 0) {
                        this.$bvToast.toast('Please select valid Contribution Percentage', { title: 'Error!', variant: 'danger', solid: true });
                        return false;
                    }
                    
                }

                formData.append('company_pf_percentage', this.company_reg_pf);
                formData.append('employee_pf_percentage', this.employee_reg_pf);
                formData.append('company_pf_status', pf_status);
            }

            axios.post(this.$api_url + '/pf/settings/save', formData, config)
                .then(function (response) {
                    if (response.data.data) {
                        this.getCompanyPFSettings();
                        this.$bvToast.toast('PF Setttings saved', { title: 'Success', variant: 'success', solid: true });

                        this.movenext = true;
                        this.showMessage();
                    } else {
                        this.$bvToast.toast('An error occurred, please try again later', { title: 'Error!', variant: 'danger', solid: true });
                    }
                    //this.scrollToTop();
                }.bind(this))
                .catch(function (error) {
                    currentObj.$bvToast.toast(error, { title: 'Error!', variant: 'danger', solid: true });
                });

        }
    },
    created: function () {
        this.getcompany();
    }
}
</script>

<style scoped>
.trz_service_button {
    display: inline-block;
    vertical-align: top;
    padding-left: 0;
}

.service_length_title[data-v-83ba1f78] {
    margin-top: 33px;
    margin-bottom: 10px;
}

.trz_service_button .v-switch-button {
    transform: translate3d(3px, 3px, 0px);
    width: 16px;
    height: 16px;
    transition: transform 300ms ease 0s;
}

.toggle_button_tax {
    margin-bottom: 10px;
}

.service_length_settings .toggle_button_tax {
    padding: 10px 0 10px 0;
    margin: 0;
}

.toggle_button_tax.first {
    border-bottom: 1px solid #dee2e6;
}

.trz_service_button.tax_toggle {
    float: right;
}

.trz_service_button.px-0.tax_toggle {
    max-width: 50px;
}

.service_format_overview {
    margin-top: 35px;
    margin-left: 15px !important;
}

.service_format_overview_td_label {
    text-align: left !important;
    font-size: 16px !important;
    width: 45% !important;
}

.service_format_overview_td_value {
    text-align: right !important;
    font-size: 16px !important;
    width: 65% !important;
    color: #004242;
}

.number_format_header_title {
    text-align: center;
    margin-bottom: 10px;
}

.service_format_overview {
    padding: 10px 10px !important;
}

#pf_loan_applicable_percent {
    display: block !important;
}
</style>
